var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallNotOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.035 0 0 4.035 0 9s4.035 9 9 9 9-4.035 9-9-4.035-9-9-9zm4.123 11.41c.469.468.469 1.244 0 1.713a1.2 1.2 0 01-.858.355 1.2 1.2 0 01-.857-.355L9 10.713l-2.41 2.41a1.2 1.2 0 01-.856.355 1.2 1.2 0 01-.858-.355 1.22 1.22 0 010-1.714L7.286 9 4.877 6.59a1.22 1.22 0 010-1.713 1.22 1.22 0 011.714 0L9 7.287l2.41-2.41a1.22 1.22 0 011.713 0c.469.47.469 1.245 0 1.714L10.713 9l2.41 2.408z",
    id: "icon_small_not_ok_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#E64D5F",
    xlinkHref: "#icon_small_not_ok_svg__a",
    fillRule: "evenodd"
  })));
}
export default SvgIconSmallNotOk;